<div class="container">
    <div class="row justify-content-center mt-5">
      <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
        <div class="card shadow">
          <div class="card-title text-center border-bottom">
            <h2 class="p-3">Reset Password</h2>
          </div>
          <div class="card-body" [ngClass]="{'cspinner load1': this.showLoader}">
            <form class="info_form p-0 m-0" (ngSubmit)="onSubmit()" [formGroup]="resetPasswordForm" #resetPasswordNgForm="ngForm">

              <div class="mb-3">
                <label for="otp" class="form-label">OTP</label>
                <input type="text" class="form-control strict_integer" autocomplete="new-password" id="otp" placeholder="Enter OTP" formControlName="otp" [readonly]="this.readOnlyField" />
                <ng-container *ngIf="resetPasswordForm.controls['otp'].dirty || resetPasswordForm.controls['otp'].touched || resetPasswordNgForm.submitted">
                  <div class="text-danger" *ngIf="resetPasswordForm?.get('otp')?.hasError('required')">
                    This field is required
                  </div>
                </ng-container>
              </div>

              <div class="mb-3" [ngClass]="{'d-none': !this.otpValidated}">
                <label for="password" class="form-label">New Password</label>
                <div class="input-group">
                  <input type="{{this.hidePassword ? 'password' : 'text'}}" autocomplete="new-password" class="form-control" placeholder="Enter new password" formControlName="newPassword">
                  <div class="input-group-append">
                    <span class="input-group-text cp" style="padding: 0.685rem 0.75rem; cursor: pointer;" (click)="this.hidePassword = !this.hidePassword">
                      <i class="fa fa-{{this.hidePassword ? 'eye-slash' : 'eye'}}"></i>
                    </span>
                  </div>
                </div>
                <ng-container *ngIf="resetPasswordForm.controls['newPassword'].dirty || resetPasswordForm.controls['newPassword'].touched || resetPasswordNgForm.submitted">
                  <div class="text-danger" *ngIf="resetPasswordForm?.get('newPassword')?.hasError('required')">
                    This field is required
                  </div>
                  <div class="text-danger" *ngIf="resetPasswordForm?.get('newPassword')?.hasError('minlength')">
                      Minimum 6 characters required
                  </div>
                  <div class="text-danger" *ngIf="resetPasswordForm?.get('newPassword')?.hasError('maxlength')">
                    Maximum 15 characters allowed
                  </div>
                </ng-container>
              </div>

              <div class="mb-3" [ngClass]="{'d-none': !this.otpValidated}">
                <label for="confirmPassword" class="form-label">Confirm New Password</label>
                <div class="input-group">
                  <input type="{{this.hideConfirmPassword ? 'password' : 'text'}}" autocomplete="new-password" class="form-control" placeholder="Confirm new password" formControlName="confirmNewPassword">
                  <div class="input-group-append">
                    <span class="input-group-text cp" style="padding: 0.685rem 0.75rem; cursor: pointer;" (click)="this.hideConfirmPassword = !this.hideConfirmPassword">
                      <i class="fa fa-{{this.hideConfirmPassword ? 'eye-slash' : 'eye'}}"></i>
                    </span>
                  </div>
                </div>
                <ng-container *ngIf="resetPasswordForm.controls['confirmNewPassword'].dirty || resetPasswordForm.controls['confirmNewPassword'].touched || resetPasswordNgForm.submitted">
                  <div class="text-danger" *ngIf="resetPasswordForm?.get('confirmNewPassword')?.hasError('required')">
                    This field is required
                  </div>
                  <div class="text-danger" *ngIf="resetPasswordForm?.get('confirmNewPassword')?.hasError('mustMatch')">
                    Confirm New Password must match with New Password
                  </div>
                </ng-container>
              </div>

              <div class="mb-3 text-right">
                <a routerLink="/login">Login</a>
              </div>

              <div class="mb-3">
                <button type="submit" class="btn btn-theme btn-block">Reset Password</button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>